import React from "react";

interface ContactProps {
  name: string;
  title: string;
  emailAddress: string;
}

export function Contact({ name, title, emailAddress }: ContactProps) {
  return (
    <div className="contact">
      <div className="contact-name">{name}</div>
      <div className="contact-title">{title}</div>
      <a href={`mailto:${emailAddress}`} className="contact-email">
        {emailAddress}
      </a>
    </div>
  );
}
